import { v4 as uuidv4 } from 'uuid';

const generateUuid = (form) => {
	let formEventId = '';

	if (form) {
		const enableLogs =
			new URLSearchParams(window.location.search).get('_mode') ===
			'debug';

		if (enableLogs) {
			// eslint-disable-next-line no-console
			console.log('formEventId:current ---->', form);
			// eslint-disable-next-line no-console
			console.log('cms-web:formEventId ----->', formEventId);
		}

		const formEventIdField = form?.querySelector?.(
			'input[name="formEventId"]'
		);

		formEventId = formEventIdField?.value;

		formEventId = uuidv4().replace(/-/g, '');
		formEventIdField?.setAttribute?.('value', formEventId);
		if (enableLogs)
			// eslint-disable-next-line no-console
			console.log(`ws-tracking:formEventId -----> ${formEventId}`);

		const actionURL = form.getAttribute('action');

		if (actionURL) {
			if (enableLogs)
				// eslint-disable-next-line no-console
				console.log(`old:actionUrl ----> ${actionURL}`);

			const formActionUrl = actionURL.split('?');
			const formActionParams = new URLSearchParams(formActionUrl[1]);
			formActionParams.set('formEventId', formEventId);
			form.setAttribute(
				'action',
				`${formActionUrl[0]}?${formActionParams.toString()}`
			);

			if (enableLogs)
				// eslint-disable-next-line no-console
				console.log(
					`new:actionUrl ----> ${form.getAttribute('action')}`
				);
		}
	}

	return formEventId;
};

export default generateUuid;
